export const LOAD_MY_UNCONFIRMED_MATCHES = "LOAD_MY_UNCONFIRMED_MATCHES";
export const LOAD_MY_UNCONFIRMED_MATCHES_SUCCESS = "LOAD_MY_UNCONFIRMED_MATCHES_SUCCESS";
export const LOAD_MY_UNCONFIRMED_MATCHES_FAILED = "LOAD_MY_UNCONFIRMED_MATCHES_FAILED";

export const LOAD_MY_CONFIRMED_MATCHES = "LOAD_MY_CONFIRMED_MATCHES";
export const LOAD_MY_CONFIRMED_MATCHES_SUCCESS = "LOAD_MY_CONFIRMED_MATCHES_SUCCESS";
export const LOAD_MY_CONFIRMED_MATCHES_FAILED = "LOAD_MY_CONFIRMED_MATCHES_FAILED";